import 'jquery'
import 'slick-carousel'
import { TweenMax } from "gsap"
import MobileDetect from 'mobile-detect/mobile-detect'

// Import everything from autoload
import 'bootstrap'

// import local dependencies
// import Router from './util/Router';
// import common from './routes/common';
// import home from './routes/home';
// import aboutUs from './routes/about';

/** Populate Router instance with DOM routes */
// const routes = new Router({
//   // All pages
//   common,
//   // Home page
//   home,
//   // About Us page, note the change from about-us to aboutUs.
//   aboutUs,
// });

// Load Events
// jQuery(document).ready(() => routes.loadEvents());

if($(window).width() < 992) {
  $('.menu-item-has-children > a').on('click', function(e) {
    e.preventDefault();
    $(this).next().toggleClass('active');
  });
}

$('.mobile-nav-tabs').on('change', function () {
  $(this).parent().prev('.nav-tabs').find('li a').eq($(this).val()).tab('show');
});


document.addEventListener("DOMContentLoaded", function () {
    // Check if there is a hash in the URL
    if (window.location.hash) {
		var windowHash = window.location.hash;
      // Get the element by the hash (removing the #)
      var targetElement = document.querySelector(windowHash);

      if (targetElement) {
        // Get the position of the element and subtract the offset
        var elementPosition = targetElement.getBoundingClientRect().top + window.pageYOffset;
        var offset = 100; // The offset

        // Scroll to the element with the offset
        window.scrollTo({
          top: elementPosition - offset,
          behavior: 'smooth' // Optional: Add smooth scrolling
        });
      }

	  // if element exists with .nav-tabs .nav-link[href="window.location.hash"] then we need to open the tab
	  var tabLink = document.querySelector('.nav-tabs .nav-link[href="'+windowHash+'"]');

	  //tabLink href has tab- as the prefix
	  if(windowHash.startsWith('#tab-')) {
		//remove the tab- prefix
		windowHash = windowHash.replace('#tab-', '#t--');
		var tabLink = document.querySelector('.nav-tabs .nav-link[href="'+windowHash+'"]');
	  }

	  if (tabLink) {
			console.log("tabLink", tabLink);
			tabLink.click();
			// Get the position of the element and subtract the offset
			var elementPosition = tabLink.getBoundingClientRect().top + window.pageYOffset;
			var offset = 175; // The offset value you want (100px for your header)
			// Scroll to the element with the offset

			window.scrollTo({
				top: elementPosition - offset,
				behavior: 'smooth' // Optional: Add smooth scrolling
			});
		}
	}
  });



var x, i, j, selElmnt, a, b, c;

x = document.getElementsByClassName('select-dropdown');
for (i = 0; i < x.length; i++) {
  selElmnt = x[i].getElementsByTagName('select')[0];

  a = document.createElement('DIV');
  a.setAttribute('class', 'select-selected');
  a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;
  x[i].appendChild(a);

  b = document.createElement('DIV');
  b.setAttribute('class', 'select-items select-hide');
  for (j = 1; j < selElmnt.length; j++) {

    c = document.createElement('DIV');
    c.innerHTML = selElmnt.options[j].innerHTML;
    c.addEventListener('click', function() {

        var y, i, k, s, h;
        s = this.parentNode.parentNode.getElementsByTagName('select')[0];
        h = this.parentNode.previousSibling;
        for (i = 0; i < s.length; i++) {
          if (s.options[i].innerHTML == this.innerHTML) {
            s.selectedIndex = i;
            h.innerHTML = this.innerHTML;
            y = this.parentNode.getElementsByClassName('same-as-selected');
            for (k = 0; k < y.length; k++) {
              y[k].removeAttribute('class');
            }
            this.setAttribute('class', 'same-as-selected');
            break;
          }
        }
        h.click();
    });
    b.appendChild(c);
  }
  x[i].appendChild(b);
  a.addEventListener('click', function(e) {
      /*when the select box is clicked, close any other select boxes,
      and open/close the current select box:*/
      e.stopPropagation();
      closeAllSelect(this);
      this.nextSibling.classList.toggle('select-hide');
      this.classList.toggle('select-arrow-active');
    });
}
function closeAllSelect(elmnt) {
  /*a function that will close all select boxes in the document,
  except the current select box:*/
  var x, y, i, arrNo = [];
  x = document.getElementsByClassName('select-items');
  y = document.getElementsByClassName('select-selected');
  for (i = 0; i < y.length; i++) {
    if (elmnt == y[i]) {
      arrNo.push(i)
    } else {
      y[i].classList.remove('select-arrow-active');
    }
  }
  for (i = 0; i < x.length; i++) {
    if (arrNo.indexOf(i)) {
      x[i].classList.add('select-hide');
    }
  }
}
/*if the user clicks anywhere outside the select box,
then close all select boxes:*/
document.addEventListener('click', closeAllSelect);

$(window).load(function() {
  var amenitiesHeight = $('.fp-amenities').outerHeight()

  if(amenitiesHeight > 600) {
    $('.fp-amenities .bg-image').addClass('tall')
  }
});

$( '.popup-modal-trigger' ).on( 'click', function() {
  var target = $(this).attr('data-target')
  $(target).addClass('show')
  $('body').addClass('tw-overflow-hidden sm:tw-overflow-auto')
});

$( '.close-popup-block' ).on( 'click', function() {
  $('.expanded-content-block').removeClass('show')
  $('body').removeClass('tw-overflow-hidden sm:tw-overflow-auto')
});

$(function() {
  $('#gmap-holder').click(function() {
      $(this).find('iframe').css('pointer-events', 'all');
  }).mouseleave(function() {
      $(this).find('iframe').css('pointer-events', 'none');
  });
})

// Notification System
let $detect = new MobileDetect(window.navigator.userAgent);


$(document).ready(function() {
  // $("div[id^=amenitiesAccordion-").on('shown.bs.collapse', function () {
  //   this.scrollIntoView();
  // });
});


if ($('#notificationModal').length) {

  let showPopup = true;

  const locationHash = window.location.hash;
  if (locationHash) {
    const locationHashElement = document.querySelector(locationHash);

    console.log(locationHashElement);
    console.log(locationHashElement.classList);
    console.log( (locationHashElement.classList.contains('gvp-anchor')) );
    console.log( (locationHashElement) );

    if (locationHashElement && locationHashElement.classList.contains('gvp-anchor')) {
      showPopup = false;
    }
  }

  if (showPopup) {
    $('#notificationModal').modal('show');
  }

}

function checkNotificationWindow() {
  console.log('check the notification window')
  let top_end = '81px'
  let top_start = '-650px'

  if($(window).width() > 992) {
    top_end = '130px'
    top_start = '-440px'
  }
  // JavaScript to be fired on the home page
  $('.bar-notification .icon').on('click', function() {
      TweenMax.to('.bar-notification-content', .5, {'top': top_end})
  })

  $('.bar-notification-content .close-btn').on('click', function() {
    TweenMax.to('.bar-notification-content', .5, {'top': top_start})
  })
}

window.addEventListener('resize', () => {
  checkNotificationWindow()
});

checkNotificationWindow()

$('#searchModal').on('shown.bs.modal', function () {
  $('#searchModalInput').trigger('focus')
})
